import { render, staticRenderFns } from "./AppLoadp.vue?vue&type=template&id=2743f584&scoped=true&"
import script from "./AppLoadp.vue?vue&type=script&lang=js&"
export * from "./AppLoadp.vue?vue&type=script&lang=js&"
import style0 from "./AppLoadp.vue?vue&type=style&index=0&id=2743f584&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743f584",
  null
  
)

export default component.exports